import { USER_LANGUAGE } from '../constants/localStorageKeys';

export default (data) => {
  localStorage.setItem(USER_LANGUAGE, data.language);
};



// WEBPACK FOOTER //
// ./src/toolbox/setUserLanguageToLocalStorage.js